<script lang="ts">
    import {
        faSearchDollar,
        faFilePdf,
        faArrowRight,
        faPlusCircle,
        faEdit,
        faUser,
        faPrint,
        faMinus,
        faPlus,
        faCheckDouble,
        faAngleLeft,
    } from '@fortawesome/free-solid-svg-icons'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { InvoicesRepository } from '../../modules/posApi/invoices/invoices.repository'
    import { InvoicesService } from '../../modules/posApi/invoices/invoices.service'
    import { Invoice, PaymentMethodsOnInvoices } from '../../modules/posApi/invoices/invoice'
    import { onMount, tick } from 'svelte'
    import { User } from '../../modules/usersApi/users/user'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import dayjs from 'dayjs'
    import DateSelect from '../_common/date-select.svelte'
    import Popover from '../_common/popover.svelte'
    import PosForm from './pos-form.svelte'
    import { PaymentMethodsRepository } from '../../modules/posApi/payment-methods/payment-methods.repository'
    import { PaymentMethodsService } from '../../modules/posApi/payment-methods/payment-methods.service'
    import { PaymentMethodTypeEnum, type PaymentMethod } from '../../modules/posApi/payment-methods/payment-methods'
    import PosEntriesStatus from './pos-entries-status.svelte'
    import {
        GridButton,
        GridClass,
        GridCol,
        GridColAlignEnum,
        GridItemShow,
        GridColTypeEnum,
        GridLine,
        GridBadge,
        GridBadgeClassEnum,
    } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'
    import PosEntriesPrint from './pos-entries-print.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import type { Entry } from '../../modules/financialApi/entries/entry'
    import { EntryTypeEnum } from '../../modules/financialApi/entries/entry.enum'
    import Financial_4AccountsForm from '../financial-4/accounts/financial-4-accounts-form.svelte'
    import Zflow from '../_common/z/zflow.svelte'
    import type { CashierEntity } from '../../modules/posApi/cashiers/cashier.entity'
    import { posCashier } from '../_common/stores'
    import CashierOpen from './cashier-open.svelte'
    import CashierClose from './cashier-close.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import TaxForm from './taxes/tax-form.svelte'
    import CashierClose_2 from './cashier-close-2.svelte'
    import { FormTemplateTypeEnum } from '../../modules/toolsApi/forms/form-templates/form-template-item-type.enum'
    import { printFormV2 } from '../customer-service-v2/forms/form-v2-print.helper'
    import Zfab from '../_common/z/zfab.svelte'

    // no celular "Nova venda" sai dos acts do grid e vira botão flutuante, como o "Agendar" da agenda
    // Largura da JANELA, não do monitor. Este mesmo isMobile decide as duas pontas da ação "Nova
    // venda": com ele falso o botão entra nos acts do grid, com ele verdadeiro sai o Zfab. Só que
    // quem mostra ou esconde o Zfab de fato é o CSS dele, por @media (max-width: 900px) — que olha
    // a janela. Com screen.width (o monitor), um Windows com escala alta ficava com os dois lados
    // discordando: o botão do grid não era criado e o Zfab ficava escondido pela media query, ou
    // seja, não havia como lançar uma venda.
    const isMobile = window.innerWidth <= 900
    let canCreateSale = false

    let grid: GridClass = new GridClass()
    let cashiersGrid: GridClass = new GridClass()
    let resumeGrid: GridClass = new GridClass()
    let resumeGridMoney: GridClass = new GridClass()
    let financialGrid: GridClass = new GridClass()

    const methodsR = new PaymentMethodsRepository()
    const methodsS = new PaymentMethodsService(methodsR)

    const rep = new InvoicesRepository()
    const service = new InvoicesService(rep)

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)

    let entries: Entry[] = []

    let show = false
    let entities: Invoice[] = []
    let dates: { from: Date; to: Date } = { from: null, to: null }
    let total: number = 0
    let totalPaid: number = 0
    let totalEntries: number = 0
    let totalResult: number = 0
    let dateSelect
    let paymentMethods: PaymentMethod[] = []
    let users: User[] = []
    let showCashierOpen = false
    let showCashierId: string = null

    dates = window.api.utils.dates.today()

    let showCashiers = false
    let cashiers: CashierEntity[] = []
    let cashier: CashierEntity = null
    let selectedCashier: string = 'global' // substitui o selectedUser
    // as opções do "Exibir": por caixa (quando a empresa usa caixa), por data de todo mundo, ou por data de um usuário
    $: cashierOptions = [
        ...(window.configs?.allowCashierStatus ? [{ value: 'cashier', label: 'Por caixa' }] : []),
        { value: 'global', label: 'Por data - Todos os usuários' },
        ...users.map((user) => ({ value: user.userId, label: 'Por data - ' + (user?.userName || '-') })),
    ]
    let selectedUserId: string = null
    onMount(async () => {
        await loadUsers()
        // await loadAll() // não deve ser chamado, pois é chamado logo abaixo, no posCahiser.subscribe
    })

    // monitora o cashier global para caso haja outra aba aberat ela se atualize.
    posCashier.subscribe(async (value) => {
        //console.log('cashier changed', value)
        cashier = value
        if (value || window.configs?.allowCashierStatus) {
            selectedUserId = null
            selectedCashier = 'cashier' // triggered at loading too... (before onMount)
            if (value) {
                showCashiers = false
                await loadAll()
            } else {
                await loadCashiers()
                showCashiers = true
            }
        } else {
            selectedCashier = 'global'
            if (!window.store.token.permissions.pos.sales.others.read) {
                selectedUserId = window.store.token.userId
                selectedUserId = selectedUserId
            }
            await loadAll()
        }
    })

    async function goCashiers() {
        posCashier.update((_) => null)
        showCashierOpen = false
        showCashierId = null
        await loadCashiers()
        showCashiers = true
    }

    // selecionou via grid um cashier
    async function cashierSelect(cashierId: string) {
        //console.log('cashierSelect', cashierId)
        let found = cashiers.find((el) => el.cashierId === cashierId)
        if (!found) {
            await loadCashiers()
            found = cashiers.find((el) => el.cashierId === cashierId)
        }
        posCashier.update((_) => found)
        showCashierOpen = false
        showCashierId = null
    }

    async function selectedCashierOnChange() {
        if (selectedCashier !== 'cashier') {
            cashier = null
            cashiers = []
            showCashiers = false
            if (selectedCashier !== 'global') {
                selectedUserId = selectedCashier
            }
            await loadAll()
        } else {
            showCashiers = true
            await loadCashiers()
        }
    }

    async function loadCashiers() {
        cashiers = []
        cashiers = await window.api.pos.cashiers.getAll({
            userId: window.store.token.permissions.pos.sales.others.read ? undefined : window.store.token.userId,
            from: dates.from,
            to: dates.to,
        })
        cashiers = await window.api.utils.utils.assignUsersFromObject(cashiers, false, 'userId', 'user')
        cashiers = cashiers

        // grid
        cashiersGrid = new GridClass()
        // grid head
        cashiersGrid.acts = [
            new GridButton({
                callback: () => goOpenCashier(),
                icon: faPlusCircle,
                label: 'Abrir novo caixa',
                color: 'primary',
            }),
        ]
        cashiersGrid.showActs = false
        cashiersGrid.title = 'Caixas no período selecionado'
        cashiersGrid.subtitle = ''
        cashiersGrid.cols.push(new GridCol({ content: 'Operador' }))
        cashiersGrid.cols.push(new GridCol({ content: 'Data de abertura', type: GridColTypeEnum.datetime }))
        cashiersGrid.cols.push(new GridCol({ content: 'Data de fechamento', type: GridColTypeEnum.datetime }))
        cashiersGrid.cols.push(new GridCol({ content: 'Divergências', type: GridColTypeEnum.float_2 }))
        cashiersGrid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        cashiersGrid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const cashier of cashiers) {
            let btns = []
            if (cashier.status > 100) {
                const btnCashier = new GridButton({
                    callback: () => (showCashierId = cashier.cashierId),
                    icon: faSearchDollar,
                    label: 'Fechamento',
                })
                btns.push(btnCashier)
            }
            const btnOpen = new GridButton({
                callback: () => cashierSelect(cashier.cashierId),
                icon: faEdit,
                label: 'Acessar',
            })
            btns.push(btnOpen)
            let line: GridLine = new GridLine()
            line.slots.push({ content: cashier['user'] ? cashier['user']['userName'] : '-' })
            line.slots.push({ content: cashier.createdAt })
            line.slots.push({ content: cashier.closedAt })
            let divergence = 0
            if (cashier.resultDivergence === null) {
                divergence = Math.round((cashier.cashOpen + cashier.cashIn - cashier.cashOut - cashier.cashResult - cashier.cashClose) * 100) / 100
            } else {
                divergence = cashier.resultDivergence
            }
            if (cashier.status > 100) {
                line.slots.push({ content: divergence })
            } else {
                line.slots.push({ content: null })
            }

            if (cashier.status === 100) {
                line.slots.push({ content: new GridBadge({ label: 'Aberto', class: 'badge_purple' }) })
            } else {
                if (divergence !== 0) {
                    line.slots.push({
                        content: [
                            new GridBadge({ label: 'Fechado', class: GridBadgeClassEnum.badge_success }),
                            new GridBadge({ label: 'divergência', class: GridBadgeClassEnum.badge_alert }),
                        ],
                    })
                } else {
                    line.slots.push({
                        content: new GridBadge({ label: 'Fechado', class: GridBadgeClassEnum.badge_success }),
                    })
                }
            }

            line.slots.push({ content: btns })
            cashiersGrid.lines.push(line)
        }
        cashiersGrid = cashiersGrid
    }

    async function loadAll() {
        // todo: se tem um cashier selecionado as funções abaixo já consideram
        console.log('selectedUserId', selectedUserId)
        clearScreen()
        await loadEntities()
        await loadFinancials()
        await evaluateDetails()
        await evaluteResume()
    }

    async function loadUsers() {
        users = await window.api.users.companies.getCompanyUsers()
    }

    $: totalResult = totalPaid + totalEntries

    interface DetailsItem {
        date: Date
        installments: number
        total: number
        net: number
    }
    interface Details {
        pm: PaymentMethod
        total: number
        net: number
        item: DetailsItem[]
    }
    let details: Details[] = []
    let detailsGrids: GridClass[] = []
    async function evaluateDetails() {
        detailsGrids = []
        details = []
        paymentMethods = await methodsS.getAll({ excluded: true }, 1200)
        for (const method of paymentMethods) {
            for (const invoice of entities) {
                for (const pm of invoice.payments) {
                    if (pm.paymentMethodId === method.paymentMethodId) {
                        let persisted = details.find((el) => el.pm.paymentMethodId === pm.paymentMethodId)
                        if (!persisted) {
                            persisted = {
                                item: [],
                                pm: method,
                                total: 0,
                                net: 0,
                            }
                            details.push(persisted)
                        }
                        let item: DetailsItem = {
                            date: invoice.createdAt,
                            installments: pm.installments,
                            total: pm.value,
                            net: calculateNetValue(pm),
                        }
                        persisted.total += pm.value
                        persisted.net += item.net
                        persisted.item.push(item)
                    }
                }
            }
        }
        for (const item of details) {
            const grid = new GridClass()
            // grid head
            grid.showActs = true
            grid.title = item.pm.label
            grid.subtitle = ''
            grid.fontSize = '13px'
            grid.showActs = false
            grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
            //grid.cols.push(new GridCol({ content: 'Pessoa' }))
            grid.cols.push(new GridCol({ content: 'Valor unit.', type: GridColTypeEnum.float_2 }))
            grid.cols.push(new GridCol({ content: 'Parcelas', type: GridColTypeEnum.int }))
            grid.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.float_2, showTotal: true }))
            grid.cols.push(new GridCol({ content: 'Líquido', type: GridColTypeEnum.float_2, showTotal: true }))
            // grid lines
            for (const entry of item.item) {
                let line: GridLine = new GridLine()
                line.slots.push({ content: entry.date })
                line.slots.push({ content: entry.total / entry.installments })
                line.slots.push({ content: entry.installments })
                line.slots.push({ content: entry.total })
                line.slots.push({ content: entry.net })
                grid.lines.push(line)
            }
            detailsGrids.push(grid)
        }
        detailsGrids = detailsGrids
    }

    function calculateNetValue(pm: PaymentMethodsOnInvoices) {
        let result = pm.value - (pm.value / 100) * pm.feePercentage - pm.feeFixed
        return result
    }

    let cashIn: number = 0
    let cashOut: number = 0
    function evaluteResume() {
        // payment methods total
        let pm: { id: string; label: string; value: number; net: number; type: string }[] = []
        for (const item of details) {
            for (const entry of item.item) {
                let found = pm.find((el) => el.id === item.pm.paymentMethodId)
                if (!found) {
                    found = {
                        id: item.pm.paymentMethodId,
                        label: item.pm.label,
                        value: 0,
                        net: 0,
                        type: item.pm.type,
                    }
                    pm.push(found)
                }
                found.net += entry.net
                found.value += entry.total
            }
        }
        let credit = entries.reduce((acc, el) => (acc += el.type === EntryTypeEnum.credit ? el.value : 0), 0)
        let debit = entries.reduce((acc, el) => (acc += el.type === EntryTypeEnum.debit ? -el.value : 0), 0)

        //
        // resumo - outras movimentações
        resumeGrid = new GridClass()
        // grid head
        resumeGrid.showActs = true
        resumeGrid.title = 'Todas as movimentações'
        resumeGrid.subtitle = ''
        resumeGrid.showActs = false
        resumeGrid.cols.push(new GridCol({ content: 'Descrição' }))
        resumeGrid.cols.push(new GridCol({ content: 'Total bruto', type: GridColTypeEnum.float_2, showTotal: true }))
        //resumeGrid.cols.push(new GridCol({ content: 'Líquido', type: GridColTypeEnum.float_2, showTotal: true }))
        // grid lines
        let line: GridLine
        for (const item of pm) {
            //if (item.type === 'money') continue
            line = new GridLine()
            line.slots.push({ content: 'Vendas - ' + item.label })
            line.slots.push({ content: item.value })
            //line.slots.push({ content: item.net })
            resumeGrid.lines.push(line)
        }
        // entradas no caixa
        line = new GridLine()
        line.slots.push({ content: 'Entradas' })
        line.slots.push({ content: credit })
        resumeGrid.lines.push(line)
        // saídas do caixa
        line = new GridLine()
        line.slots.push({ content: 'Saídas' })
        line.slots.push({ content: debit })
        resumeGrid.lines.push(line)
        //
        resumeGrid = resumeGrid
        //
        //

        //
        // resumo - outras movimentações
        cashIn = 0
        cashOut = 0
        resumeGridMoney = new GridClass()
        // grid head
        resumeGridMoney.showActs = true
        resumeGridMoney.title = 'Movimentação em dinheiro'
        resumeGridMoney.subtitle = ''
        resumeGridMoney.showActs = false
        resumeGridMoney.cols.push(new GridCol({ content: 'Descrição' }))
        resumeGridMoney.cols.push(new GridCol({ content: 'Total calculado', type: GridColTypeEnum.float_2, showTotal: false }))
        resumeGridMoney.cols.push(new GridCol({ content: 'Total informado', type: GridColTypeEnum.float_2, showTotal: false }))
        resumeGridMoney.cols.push(new GridCol({ content: 'Divergências', type: GridColTypeEnum.float_2, showTotal: false }))
        // cashier money start
        if (cashier) {
            line = new GridLine()
            line.slots.push({ content: '+ Caixa inicial para troco' })
            line.slots.push({ content: cashier.cashOpen })
            line.slots.push({ content: cashier.cashOpen })
            line.slots.push({ content: null })
            resumeGridMoney.lines.push(line)
        }
        //
        let declaredCashIn = 0
        let declaredCashOut = 0
        if (cashier && cashier.status > 100) {
            declaredCashIn = cashier.result?.reduce((acc, v) => (v.id == 'in' ? acc + v.informed : acc), 0)
            declaredCashOut = cashier.result?.reduce((acc, v) => (v.id == 'out' ? acc + v.informed : acc), 0)
        }

        let totalMoneySalesDiff = 0
        let inDiff = 0
        let outDiff = 0
        for (const item of pm) {
            if (item.type !== 'money') continue
            const money = cashier.result?.reduce((acc, v) => (v.type == 'money' && v.id == item.id ? acc + v.informed : acc), 0)
            const moneySalesDiff = money - item.value
            totalMoneySalesDiff += moneySalesDiff
            line = new GridLine()
            line.slots.push({ content: '+ Vendas - ' + item.label })
            line.slots.push({ content: item.value })
            line.slots.push({ content: money })
            line.slots.push({ content: moneySalesDiff })
            //line.slots.push({ content: item.net })
            resumeGridMoney.lines.push(line)
            cashIn += item.value
        }

        // entradas no caixa
        inDiff = declaredCashIn - credit
        line = new GridLine()
        line.slots.push({ content: '+ Entradas' })
        line.slots.push({ content: credit })
        line.slots.push({ content: declaredCashIn })
        line.slots.push({ content: inDiff })
        resumeGridMoney.lines.push(line)
        cashIn += credit

        // saídas do caixa
        outDiff = -declaredCashOut - debit
        line = new GridLine()
        line.slots.push({ content: '- Saídas' })
        line.slots.push({ content: debit })
        line.slots.push({ content: -declaredCashOut })
        line.slots.push({ content: outDiff })
        resumeGridMoney.lines.push(line)
        cashOut += -debit

        // // cashier money end
        // line = new GridLine()
        // line.slots.push({ content: '- Troco deixado na gaveta' })
        // line.slots.push({ content: null })
        // line.slots.push({ content: -cashier.cashClose })
        // line.slots.push({ content: null })
        // resumeGridMoney.lines.push(line)
        //
        const diff = totalMoneySalesDiff + inDiff + outDiff
        //
        line = new GridLine()
        line.slots.push({ content: '= Divergência de caixa' })
        line.slots.push({ content: null })
        line.slots.push({ content: null })
        line.slots.push({ content: diff })
        resumeGridMoney.lines.push(line)
        if (diff !== 0) {
            const helper = diff < 0 ? 'faltando' : 'sobrando'
            resumeGridMoney.subtitle = 'Há uma divergência no caixa atual de ' + diff.toFixed(2) + ' (' + helper + ')'
        }

        //
        resumeGridMoney = resumeGridMoney
    }

    async function loadEntities() {
        try {
            show = true
            entities = []
            const filter = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                payment: true,
                userId: selectedUserId || undefined,
                cashierId: cashier?.cashierId || undefined,
            }

            // limita a navegação por mais de 7 dias
            if (!window.store.token.permissions.pos.sales.navigate) {
                const diff = dayjs(new Date()).diff(filter.from, 'days')
                if (diff > 7) {
                    dates.from = dayjs(new Date()).add(-7, 'day').toDate()
                    filter.from = dates.from
                    dateSelect.setDate(dates.from, dates.to)
                }
            }

            entities = await service.getAll(filter, 60)
            let persons: Person[] = []
            let personsId = []
            for (const invoice of entities) {
                personsId.push(invoice.personId)
            }

            let promises = []
            for (let i = 0; i < personsId.length; i += 100) {
                const chunk = personsId.slice(i, i + 100)
                promises.push(personsS.getAll({ persons: chunk.join(',') }, 600))
            }
            const results = await Promise.all(promises)
            for (const result of results) {
                persons = persons.concat(result)
            }

            //users = await compS.getCompanyUsers()
            total = 0
            totalPaid = 0
            for (let invoice of entities) {
                invoice.person = persons.find((el) => el.personId === invoice.personId)
                //invoice.user = users.find((el) => el.userId === invoice?.userId)
                total += invoice.total
                totalPaid += invoice.payments.reduce((acc, el) => (acc += el.value), 0)
            }
            totalResult = totalPaid
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }

        loadGrid()
    }

    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showActs = !cashier
        grid.title = 'Vendas Realizadas'
        canCreateSale =
            window.store.token.permissions.pos.sales.write &&
            (!selectedUserId || selectedUserId === window.store.token.userId) &&
            (!cashier || cashier.status === 100)
        // no celular a mesma ação aparece no Zfab, logo abaixo do conteúdo
        if (canCreateSale && !isMobile) {
            grid.acts = [
                new GridButton({
                    label: 'Nova venda',
                    icon: faPlusCircle,
                    mobileShowLabel: false,
                    color: 'primary',
                    callback: () => {
                        newEntity()
                    },
                }),
            ]
        }
        grid.subtitle = ''
        grid.cols.push(
            new GridCol({
                content: 'Status',
                type: GridColTypeEnum.button,
                align: GridColAlignEnum.left,
            }),
        )
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Pessoa', mobile: GridItemShow.show }))
        grid.cols.push(new GridCol({ content: 'Itens', type: GridColTypeEnum.float_2, showTotal: true, showTotalBox: false }))
        grid.cols.push(
            new GridCol({
                content: 'Total pago',
                type: GridColTypeEnum.float_2,
                showTotal: true,
                showTotalBox: false,
            }),
        )
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let line: GridLine = new GridLine()
            line.slots.push({
                content: [
                    new GridButton({
                        class: 'btn badge status_' + item.status,
                        icon: faCheckDouble,
                        label: translateStatus(item.status),
                        callback: () => {
                            changeStatus(item.invoiceId)
                        },
                    }),
                ],
            })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.person?.name })
            line.slots.push({ content: item.total })
            line.slots.push({ content: item.totalPaid })

            let btns = []

            let btnNFSe = null
            if (window.store.token.permissions.pos.taxInvoices.write) {
                if (item.taxInvoiceId) {
                    btnNFSe = new GridButton({
                        icon: faFilePdf,
                        label: 'Imprimir NFSe',
                        callback: () => {
                            getPDF(item.taxInvoiceId, item.person?.name)
                        },
                    })
                } else {
                    btnNFSe = new GridButton({
                        icon: faArrowRight,
                        label: 'Emitir NFSe',
                        callback: () => {
                            SendNFSe(item.invoiceId)
                        },
                    })
                }
                btns.push(btnNFSe)
            }

            let btnPerson = new GridButton({
                icon: faUser,
                label: 'Pessoa',
                callback: () => {
                    showPerson(item.person?.personId)
                },
            })
            btns.push(btnPerson)

            let btnEdit = new GridButton({
                icon: faEdit,
                label: 'Editar',
                callback: () => {
                    editEntity(item.invoiceId)
                },
            })
            btns.push(btnEdit)

            let btnPrint = new GridButton({
                icon: faPrint,
                label: '',
                mobile: GridItemShow.hide,
                callback: () => {
                    showPrint(item.invoiceId, item.person?.personId)
                },
            })
            btns.push(btnPrint)

            line.slots.push({
                content: btns,
            })
            grid.lines.push(line)
        }
        grid = grid
    }

    function evaluateError(error) {
        window.error(error)
    }

    async function dateChanged(event) {
        dates = event.detail
        console.log('date_changed', dates)
        if (selectedCashier === 'cashier') {
            await loadCashiers()
        } else {
            await loadAll()
        }
    }

    function showPerson(personId) {
        window.person('show', personId)
    }

    let showForm = false
    let invoiceId: string = null
    function editEntity(id) {
        invoiceId = id
        showForm = true
    }
    function newEntity() {
        if (cashier && cashier?.userId !== window.store.user.userId) {
            window.error('Apenas o usuário responsável por este caixa pode fazer lançamentos.')
            return
        }
        invoiceId = null
        showForm = true
    }
    function formChanged() {
        loadAll()
        showForm = false
    }
    function formCanceled() {
        showForm = false
    }

    function generatePayment(payments: PaymentMethodsOnInvoices) {}

    let showFinancial = false
    let entryId: string = null
    let creditDebit: EntryTypeEnum = null
    function editFinancial(id) {
        entryId = id
        showFinancial = true
    }

    function newFinancial(_creditDebit: EntryTypeEnum) {
        console.log('yes')
        if (cashier && cashier?.userId !== window.store.user.userId) {
            window.error('Apenas o usuário responsável por este caixa pode fazer lançamentos.')
            return
        }
        entryId = null
        creditDebit = _creditDebit
        showFinancial = true
    }

    function financialChanged() {
        loadFinancials()
        evaluteResume()
        showFinancial = false
    }
    function financialCanceled() {
        loadFinancials() // como podem ocorrer lançamentos em sequencia e depois o usuário sair clicando em "fechar", sempre atualizar
        showFinancial = false
    }

    async function loadFinancials() {
        try {
            show = true
            entries = []
            const filter = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                bank: '9980',
                userId: selectedUserId || undefined,
                cashierId: cashier?.cashierId || undefined,
            }

            // limita a navegação por mais de 7 dias
            if (!window.store.token.permissions.pos.sales.navigate) {
                const diff = dayjs(new Date()).diff(filter.from, 'days')
                if (diff > 7) {
                    dates.from = dayjs(new Date()).add(-7, 'day').toDate()
                    filter.from = dates.from
                    dateSelect.setDate(dates.from, dates.to)
                }
            }
            entries = await window.api.financials.entries.getAll(filter, 60)
            let persons: Person[] = []
            let personsId = []
            for (const entry of entries) {
                personsId.push(entry.personId)
            }
            let promises = []
            for (let i = 0; i < personsId.length; i += 100) {
                const chunk = personsId.slice(i, i + 100)
                promises.push(personsS.getAll({ persons: chunk.join(',') }, 600))
            }
            const results = await Promise.all(promises)
            for (const result of results) {
                persons = persons.concat(result)
            }
            for (let entry of entries) {
                entry.person = persons.find((el) => el.personId === entry.personId)
            }
            totalEntries = entries.reduce((acc, el) => (acc += el.type === EntryTypeEnum.credit ? el.value : -el.value), 0)
            entries = entries
            loadFinancialGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function loadFinancialGrid() {
        // grid
        financialGrid = new GridClass()
        // grid head
        financialGrid.showActs = !cashier
        financialGrid.title = 'Entradas e Saídas'
        financialGrid.subtitle = ''
        if (window.store.token.permissions.pos.sales.write) {
            if (!selectedUserId || selectedUserId === window.store.token.userId) {
                if (!cashier || cashier.status === 100) {
                    financialGrid.acts = [
                        new GridButton({
                            label: 'Entrada',
                            color: 'primary',
                            icon: faPlus,
                            mobileShowLabel: false,
                            callback: () => {
                                newFinancial(EntryTypeEnum.credit)
                            },
                        }),
                        new GridButton({
                            label: 'Saída',
                            color: 'primary',
                            icon: faMinus,
                            mobileShowLabel: false,
                            callback: () => {
                                newFinancial(EntryTypeEnum.debit)
                            },
                        }),
                    ]
                }
            }
        }
        financialGrid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.date }))
        financialGrid.cols.push(new GridCol({ content: 'Empresa / Pessoa' }))
        financialGrid.cols.push(new GridCol({ content: 'Categoria' }))
        financialGrid.cols.push(new GridCol({ content: 'Descrição' }))
        financialGrid.cols.push(
            new GridCol({
                content: 'Valor',
                type: GridColTypeEnum.float_2,
                showTotal: true,
            }),
        )
        financialGrid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entries) {
            let line: GridLine = new GridLine()
            line.class = 'type_' + item.type
            line.slots.push({ content: item.paymentAt })
            line.slots.push({ content: item.person?.name })
            line.slots.push({ content: item.category?.label })
            line.slots.push({ content: item.description })
            line.slots.push({ content: item.type === 'credit' ? item.value : -item.value })
            line.slots.push({
                content: [
                    new GridButton({
                        icon: faUser,
                        label: '',
                        callback: () => {
                            showPerson(item.person?.personId)
                        },
                    }),
                    new GridButton({
                        icon: faEdit,
                        label: 'Editar',
                        callback: () => {
                            editFinancial(item.entryId)
                        },
                    }),
                ],
            })
            financialGrid.lines.push(line)
        }
        financialGrid = financialGrid
    }
    function translateStatus(status) {
        if (status === 'open') return 'Aberto'
        if (status === 'closed') return 'Fechado'
        if (status === 'subsidized') return 'Baixado'
        if (status === 'credit') return 'Crédito'
        if (status === 'budget') return 'Orçamento'
        return 'Parcial'
    }

    function statusCanceled() {
        statusInvoiceId = null
    }

    let statusInvoiceId = null
    function changeStatus(invoiceId) {
        statusInvoiceId = invoiceId
    }

    function onStatusChanged() {
        loadAll()
        statusInvoiceId = null
    }

    let showPrintObject: { personId: string; invoiceId: string } = null
    function showPrint(invoiceId: string, personId: string) {
        if (!window.configs?.posPrintVersionLatest) {
            showPrintObject = {
                invoiceId,
                personId,
            }
        }
        if (window.configs?.documentVersionLatest) {
            window.popover({
                act: 'customer-service-v2',
                data: {
                    view: false,
                    personId,
                    invoiceId,
                    types: [FormTemplateTypeEnum.contrato, FormTemplateTypeEnum.recibo],
                },
                callback: checkPrintV2,
            })
        } else {
            window.popover({
                act: 'customer-service',
                data: {
                    view: false,
                    personId: personId,
                    invoiceId: invoiceId,
                    types: [FormTemplateTypeEnum.contrato, FormTemplateTypeEnum.recibo],
                },
                callback: checkPrint,
            })
        }
        return
    }

    async function checkPrint(data) {
        if (!data.formDataId) return
        if (!confirm('Deseja imprimir o documento?')) return
        setTimeout(() => {
            window.popover({
                act: 'customer-service',
                data: {
                    formDataId: data.formDataId,
                    view: true,
                },
            })
        }, 1000)
    }

    async function checkPrintV2(data) {
        if (!data.formV2FormId) return
        if (!confirm('Deseja imprimir o documento?')) return
        try {
            show = true
            await printFormV2(data.formV2FormId)
        } finally {
            show = false
        }
    }

    function goOpenCashier() {
        showCashierOpen = true
    }

    function goCloseCashier() {
        showCashierId = cashier.cashierId
    }

    async function goReopenCashier() {
        if (!confirm('Deseja mesmo reabrir este caixa?')) return
        try {
            await window.api.pos.cashiers.reopen(cashier.cashierId)
            await goCashiers()
        } catch (error) {
            window.error(error)
        }
    }

    function clearScreen() {
        grid = new GridClass()
        cashiersGrid = new GridClass()
        resumeGrid = new GridClass()
        resumeGridMoney = new GridClass()
        financialGrid = new GridClass()
    }

    let invoiceToNFSe: Invoice = null

    async function SendNFSe(invoiceId: string) {
        invoiceToNFSe = await window.api.pos.invoices.getOne(invoiceId)
    }

    async function getRPS(taxInvoiceId) {
        try {
            show = true
            window.api.utils.utils.saveResponseAs(await window.api.pos.taxInvoices.getRPS(taxInvoiceId), 'application/pdf')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function getPDF(taxInvoiceId: string, personName: string) {
        try {
            show = true
            // a linha é a venda: número e data de emissão vêm da própria nota, para o nome do arquivo
            const [pdf, taxI] = await Promise.all([
                window.api.pos.taxInvoices.getPDF(taxInvoiceId),
                window.api.pos.taxInvoices.getOne(taxInvoiceId),
            ])
            window.api.utils.utils.saveResponseAs(pdf, 'application/pdf', window.api.pos.taxInvoices.fileName(taxI, personName, 'pdf'))
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function onCancelNFSe() {
        invoiceToNFSe = null
    }

    function onChangeNFSe() {
        invoiceToNFSe = null
        loadEntities()
    }
</script>

{#if invoiceToNFSe}
    <Popover title="Emitir NFSe" width="1300px" height="100px" on:close={onChangeNFSe}>
        <TaxForm invoice={invoiceToNFSe} on:cancel={onCancelNFSe} on:change={onChangeNFSe}></TaxForm>
    </Popover>
{/if}

{#if statusInvoiceId}
    <Popover title="Alterar status do recebimento" width="620px" height="155px" on:close={statusCanceled}>
        <PosEntriesStatus invoiceId={statusInvoiceId} on:change={onStatusChanged} on:cancel={statusCanceled} />
    </Popover>
{/if}

{#if showFinancial}
    <Popover title="Lançamento no caixa do PDV" width="1100px" height="360px" on:close={financialCanceled}>
        <Financial_4AccountsForm bank="9980" {creditDebit} {entryId} cashierId={cashier?.cashierId} on:change={financialChanged}></Financial_4AccountsForm>
    </Popover>
{/if}

{#if showForm}
    <Popover
        title="Venda"
        width="1300px"
        height="90vh"
        on:close={() => {
            showForm = false
        }}
    >
        <PosForm {invoiceId} on:change={formChanged} on:cancel={formCanceled} />
    </Popover>
{/if}

{#if showPrintObject}
    <Popover title="Imprimir" width="420px" height="255px" on:close={() => (showPrintObject = null)}>
        <PosEntriesPrint personId={showPrintObject.personId} invoiceId={showPrintObject.invoiceId} />
    </Popover>
{/if}

{#if showCashierOpen}
    <Popover title="Abrir caixa" width="620px" height="100px" on:close={() => (showCashierOpen = false)}>
        <CashierOpen on:open={(ev) => cashierSelect(ev.detail)}></CashierOpen>
    </Popover>
{/if}

{#if showCashierId}
    <Popover title="Fechar caixa" width="640px" height="100px" on:close={() => (showCashierId = null)}>
        <!-- <CashierClose cashOpen={cashier?.cashOpen} {cashIn} {cashOut} cashierId={cashier?.cashierId} on:close={goCashiers}></CashierClose> -->
        <CashierClose_2 cashierId={showCashierId} on:close={goCashiers}></CashierClose_2>
    </Popover>
{/if}

<Content footer={true}>
    <Zact>
        {#if !cashier}
            {#if window.store.token.permissions.pos.sales.others.read}
                {#if window.featureFlags.includes('cashier') || window.configs?.allowCashier}
                    <div class="pos-filter h-print">
                        <Zinput label="Exibir" type="select" options={cashierOptions} bind:value={selectedCashier} on:change={selectedCashierOnChange} />
                    </div>
                {/if}
            {/if}
            <DateSelect bind:this={dateSelect} on:change={dateChanged} />
            <div class="spacer h-mobile" />
            <Zbutton class="h-mobile" icon={faPrint} title="Imprimir" on:click={() => window.print()} />
        {:else}
            <Zbutton color="secondary" icon={faAngleLeft} label="Exibir caixas" on:click={goCashiers} />
            <div class="spacer h-mobile cashier-label">
                <div>
                    {#if cashier.cashierId}
                        Caixa de {users.find((el) => el.userId === cashier.userId)?.userName || '-'} aberto em {dayjs(cashier.createdAt).format(
                            'DD/MM/YYYY HH:mm:ss',
                        )}
                    {/if}
                </div>
            </div>
            <Zbutton class="h-mobile" icon={faPrint} title="Imprimir" on:click={() => window.print()} />
            {#if cashier.status === 100}
                <Zbutton class="h-mobile" icon={faEdit} label="Fechar caixa" on:click={goCloseCashier} />
            {:else}
                <Zbutton class="h-mobile" icon={faEdit} label="Reabrir caixa" on:click={goReopenCashier} />
            {/if}
        {/if}
    </Zact>

    {#if showCashiers}
        <Zgrid class="h-space" grid={cashiersGrid} />
    {:else}
        <Zgrid class="h-space" {grid} />
        <Zgrid class="h-space" grid={financialGrid} />

        {#if cashier}
            <Zgrid class="h-space" grid={resumeGridMoney}></Zgrid>
        {/if}
        <Zgrid class="h-space" grid={resumeGrid}></Zgrid>
        <!-- <Zframe
            class="h-space"
            title="Resumo das movimentações"
            headline="Utilize o resumo para conferir suas movimentações."
        >
            <div class="row">
                <div class="col-md-6">
                    <Zgrid class="h-space" grid={resumeGridMoney}></Zgrid>
                </div>
                <div class="col-md-6">
                    <Zgrid class="h-space" grid={resumeGrid}></Zgrid>
                </div>
            </div>
        </Zframe> -->
        {#if window.store.token.permissions.pos.sales.details}
            {#if window.configs.posShowDetails && details.length > 0}
                <Zframe class="h-space" title="Detalhamento das vendas" headline="O 'líquido' representa o total descontando as taxas do meio de pagamento.">
                    <Zflow>
                        {#each detailsGrids as grid}
                            <Zgrid {grid}></Zgrid>
                        {/each}
                    </Zflow>
                </Zframe>
            {/if}
        {/if}
    {/if}

    <LoadSpinner {show} />
</Content>

<!-- celular: a ação principal da tela flutua no canto, como o "Agendar" da agenda -->
{#if isMobile && canCreateSale && !showCashiers}
    <Zfab label="Nova venda" icon={faPlusCircle} on:click={newEntity} />
{/if}

<style>
    .pos-filter {
        width: 280px;
        max-width: 100%;
    }

    .cashier-label {
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .cashier-label > div {
        background-color: #88888820;
        padding: 4px 8px;
        border-radius: 4px;
        opacity: 0.85;
    }
</style>
